import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import clsx from 'clsx';
import React from 'react'
import { Helmet } from 'react-helmet'
const url = new URL(window.location.href);
const finalUrl = `/api/`;

// Const for register
  const pageUrl   = 'https://www.aiatedu.com/register'
  const pageTitle = 'Register | AIAT'
  const pageDesc  =
    'Create a free AIAT account to access AI-powered math tutoring, past papers, quizzes, and personalized learning tools.'


const CreateButton = ({ children, ...rest }) => {
  const additionalClassName =
    'w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500';

  const combinedClassName = clsx(rest.className, additionalClassName);
  return (
    <Button className={combinedClassName} {...rest}>
      {children}
    </Button>
  );
};

function Header() {
  return (
    <div className="text-center space-y-3">
      <h2 className="text-4xl font-extrabold text-[#b82322]">
        Join AIAT for free
      </h2>
    </div>
  );
}

function InputField({ agreeToTerms }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [role, setRole] = useState('student');
  const [accessCode, setAccessCode] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState('weak');
  const navigate = useNavigate();

  const checkPasswordStrength = (pass) => {
    const hasNumber = /\d/.test(pass);
    const hasLetter = /[a-zA-Z]/.test(pass);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(pass);
    if (pass.length < 8) return 'weak';
    if (hasNumber && hasLetter && hasSpecial && pass.length >= 12)
      return 'strong';
    if (
      (hasNumber && hasLetter) ||
      (hasLetter && hasSpecial) ||
      (hasNumber && hasSpecial)
    )
      return 'medium';
    return 'weak';
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }
    if (!agreeToTerms) {
      alert('Please agree to the terms and conditions');
      return;
    }
    if (role === 'teacher' && !accessCode) {
      alert('Please enter your teacher access code');
      return;
    }

    try {
      const response = await axios.post(finalUrl.concat('register'), {
        username: email,
        email: email,
        password,
        role,
        accessCode,
        fullName: name,
      });
      console.log('Registration successful', response.data);
      alert('Registration successful');
      navigate('/login');
    } catch (error) {
      if (error) {
        if (error.response) {
          alert(error.response.data.error);
        } else {
          alert('An error occured. Please try again later.');
        }
      }
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordStrength(checkPasswordStrength(newPassword));
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <>
     <Helmet>
        {/* 1. Usercentrics CMP */}
        <script
          id="usercentrics-cmp"
          src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
          data-settings-id="R7Xi1xeFRKhrKk"
          async
        />

        {/* 2. Google Analytics (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-17303305286"
        />
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-17303305286');
        `}</script>

        {/* 3a. Google Tag Manager (head) */}
        <script>{`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
            j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-MBKBFC9M');
        `}</script>

        {/* Browser tab title */}
        <title>{pageTitle}</title>

        {/* Basic SEO */}
        <meta name="description" content={pageDesc} />
        <meta
          name="keywords"
          content="register, sign up, AI tutor, math AI, AIAT, online learning"
        />

        {/* Favicon */}
        <link rel="icon" href="/favicon.ico" />

        {/* Open Graph */}
        <meta property="og:type"        content="website" />
        <meta property="og:title"       content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:url"         content={pageUrl} />

        {/* Twitter Card */}
        <meta name="twitter:card"        content="summary" />
        <meta name="twitter:title"       content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
      </Helmet>
    <div>
      {/* <form className="mt-6 space-y-5" onSubmit={handleRegister}>
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <div className="mb-4">
              <div className="relative mb-4">
                <button
                  type="button"
                  onClick={() => setIsOpen(!isOpen)}
                  style={{
                    border: '1px solid #d1d5db', // border-gray-300
                    borderRadius: '0.375rem', // rounded-md
                    backgroundColor: 'white',
                    padding: '0.75rem 1rem', // px-4 py-3
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'border-color 0.2s ease',
                    ':hover': {
                      borderColor: '#991b1b', // hover:border-red-800
                    },
                    ':focus': {
                      outline: 'none',
                      boxShadow: '0 0 0 2px #991b1b', // focus:ring-2 focus:ring-red-600
                    },
                  }}
                >
                  <div className="flex items-center space-x-2">
                    <i
                      className={`${
                        role === 'student'
                          ? 'fas fa-user-graduate'
                          : 'fas fa-chalkboard-teacher'
                      } ${
                        role === 'student' ? 'text-red-800' : 'text-red-800'
                      }`}
                    ></i>
                    <span className="text-sm font-medium text-black">
                      {role === 'student' ? 'Student' : 'Teacher'}
                    </span>
                  </div>
                  <i className="fas fa-chevron-down text-gray-400"></i>
                </button>
                {isOpen && (
                  <div className="absolute w-full mt-1 bg-white border rounded-md shadow-lg z-10">
                    <div
                      className="flex items-center space-x-2 px-4 py-3 hover:bg-red-50 cursor-pointer"
                      onClick={() => {
                        setRole('student');
                        setIsOpen(false);
                      }}
                    >
                      <i className="fas fa-user-graduate text-red-800"></i>
                      <span className="text-sm">Student</span>
                    </div>
                    <div
                      className="flex items-center space-x-2 px-4 py-3 hover:bg-red-50 cursor-pointer"
                      onClick={() => {
                        setRole('teacher');
                        setIsOpen(false);
                      }}
                    >
                      <i className="fas fa-chalkboard-teacher text-red-800"></i>
                      <span className="text-sm">Teacher</span>
                    </div>
                  </div>
                )}
              </div>
              {role === 'teacher' && (
                <div className="mb-4">
                  <label htmlFor="access-code" className="sr-only">
                    Access Code
                  </label>
                  <input
                    id="access-code"
                    name="access-code"
                    type="text"
                    required
                    className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                    placeholder="Access Code"
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value)}
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Please enter your teacher access code
                  </p>
                </div>
              )}
              <label htmlFor="name" className="sr-only">
                Full Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="name"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <div>
            <label htmlFor="email-address" className="sr-only">
              Email Address
            </label>
            <input
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="sr-only">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
            />
          </div>
          <div>
            <label htmlFor="confirm-password" className="sr-only">
              Confirm Password
            </label>
            <input
              id="confirm-password"
              name="confirm-password"
              type="password"
              autoComplete="new-password"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
        </div>
        <div className="flex flex-col space-y-2">
          <div className="text-sm text-gray-600">Password strength:</div>
          <div className="h-2 bg-gray-200 rounded-full">
            <div
              className={`h-full rounded-full transition-all duration-300 ${
                passwordStrength === 'weak'
                  ? 'w-1/3 bg-red-500'
                  : passwordStrength === 'medium'
                    ? 'w-2/3 bg-yellow-500'
                    : 'w-full bg-green-500'
              }`}
            ></div>
          </div>
          <p className="text-xs text-gray-500">
            Password must be at least 8 characters long and contain letters,
            numbers, and special characters
          </p>
        </div>
        <div className="flex items-center">
          <input
            id="agree-terms"
            name="agree-terms"
            type="checkbox"
            className="h-4 w-4 text-red-700 focus:ring-red-600 border-gray-300 rounded"
            checked={agreeToTerms}
            onChange={(e) => setAgreeToTerms(e.target.checked)}
          />
          <label
            htmlFor="agree-terms"
            className="ml-2 block text-sm text-gray-900"
          >
            I agree to the{' '}
            <a
              href="/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-700 hover:text-red-600"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-700 hover:text-red-600"
            >
              Privacy Policy
            </a>
          </label>
        </div>
        <div>
          <button
            type="submit"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-800 hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 !rounded-button whitespace-nowrap"
          >
            Create Account
          </button>
        </div>
      </form> */}
      <div className="flex border-b mb-6">
        <button
          onClick={() => setRole('student')}
          className={`pb-2 text-lg font-medium px-6 text-left flex-1 ${
            role === 'student'
              ? 'text-[#bb3a3d] border-b-2 border-red-600'
              : 'text-gray-400'
          }`}
        >
          I am a student
        </button>
        <button
          onClick={() => setRole('teacher')}
          className={`pb-2 text-lg font-medium px-6 text-left flex-1 ${
            role === 'teacher'
              ? 'text-[#bb3a3d] border-b-2 border-red-600'
              : 'text-gray-400'
          }`}
        >
          I am a teacher
        </button>
      </div>
      <form
        className="mt-8 space-y-6 md:space-y-6 sm:space-y-4"
        onSubmit={handleRegister}
      >
        <div className="space-y-4">
          <div>
            <input
              id="email"
              name="email"
              type="email"
              required
              className="appearance-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 text-sm"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="relative">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              required
              className="appearance-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 text-sm"
              placeholder="Password (at least 6 characters)"
              value={password}
              onChange={handlePasswordChange}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i
                className={`fas ${
                  showPassword ? 'fa-eye-slash' : 'fa-eye'
                } text-gray-400`}
              ></i>
            </button>
          </div>
          <div className="relative">
            <input
              id="confirmPassword"
              name="confirmPassword"
              type={showConfirmPassword ? 'text' : 'password'}
              required
              className="appearance-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 text-sm"
              placeholder="Confirm Password (Consistent with password)"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              <i
                className={`fas ${
                  showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'
                } text-gray-400`}
              ></i>
            </button>
          </div>
          <div>
            <input
              id="fullName"
              name="fullName"
              type="text"
              required
              className="appearance-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 text-sm"
              placeholder="Full name (required)"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          {role === 'teacher' && (
            <div>
              <input
                id="accessCode"
                name="accessCode"
                type="text"
                required
                className="appearance-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 text-sm"
                placeholder="Access Code"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
              />
            </div>
          )}
        </div>
        <div className="flex flex-col space-y-2">
          <div className="text-sm text-gray-600">Password strength:</div>
          <div className="h-2 bg-gray-200 rounded-full">
            <div
              className={`h-full rounded-full transition-all duration-300 ${
                passwordStrength === 'weak'
                  ? 'w-1/3 bg-red-500'
                  : passwordStrength === 'medium'
                    ? 'w-2/3 bg-yellow-500'
                    : 'w-full bg-green-500'
              }`}
            ></div>
          </div>
          <p className="text-xs text-gray-500">
            Password must be at least 8 characters long and contain letters,
            numbers, and special characters
          </p>
        </div>
        <div>
          <CreateButton
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Create Account
          </CreateButton>
        </div>
      </form>
    </div>
    </>
  );
}

function Footer() {
  return (
    <div className="text-center text-sm">
      <span className="text-gray-600">Already have an account? </span>
      <a href="/login" className="font-medium text-red-600 hover:text-red-500">
        Login
      </a>
    </div>
  );
}

export default function Register() {
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-gray-50 flex flex-col justify-center items-center px-4 py-20">
      <div className="w-[520px] min-h-[680px] space-y-6 bg-white p-12 rounded-lg shadow-xl">
        <Header />
        <InputField
          agreeToTerms={agreeToTerms}
          setAgreeToTerms={setAgreeToTerms}
        />
        <Footer />
      </div>
      <div className="flex items-center justify-between mt-3">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="terms"
              name="agreeToTerms"
              type="checkbox"
              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
            />
          </div>
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="terms" className="text-gray-500">
            By using AIAT, you agree to our{' '}
            <a href="#" className="text-gray-600 hover:text-gray-900">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="#" className="text-gray-600 hover:text-gray-900">
              Privacy Policy
            </a>
            .
          </label>
        </div>
      </div>
    </div>
  );
}
